import type {
  ClassSuggestion,
  CopyData,
  EasyLearning,
  LearningSuggestion,
  ListenNReadResponse,
  RecordSubjectResponse,
  TotalListenNReadResponse,
  TotalRecordSubjectResponse
} from '@/models/interface/learningProgress';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class LearningProgressService extends ApiFactory {
  constructor() {
    super('LearningMap');
  }

  easyLearning(): Promise<ApiDataResponse<EasyLearning>> {
    return super.get(`EasyLearning`);
  }

  totalEasyLearning(): Promise<ApiDataResponse<EasyLearning>> {
    return super.get(`TotalEasyLearning`);
  }

  listenNRead(): Promise<ApiDataResponse<ListenNReadResponse>> {
    return super.get(`ListenNRead`);
  }

  totalListenNRead(): Promise<ApiDataResponse<TotalListenNReadResponse>> {
    return super.get(`TotalListenNRead`);
  }

  requiredSubject(): Promise<ApiDataResponse<RecordSubjectResponse>> {
    return super.get(`RequiredSubject`);
  }

  totalRequiredSubject(): Promise<ApiDataResponse<TotalRecordSubjectResponse>> {
    return super.get(`TotalRequiredSubject`);
  }

  electiveSubject(): Promise<ApiDataResponse<RecordSubjectResponse>> {
    return super.get(`ElectiveSubject`);
  }

  totalElectiveSubject(): Promise<ApiDataResponse<TotalRecordSubjectResponse>> {
    return super.get(`TotalElectiveSubject`);
  }

  getCopyData(): Promise<ApiDataResponse<CopyData[]>> {
    return super.get(`GetCopyData`);
  }

  classSuggestion(): Promise<ApiDataResponse<ClassSuggestion[]>> {
    return super.get(`ClassSuggestion`);
  }

  learningSuggestion(): Promise<ApiDataResponse<LearningSuggestion>> {
    return super.get(`LearningSuggestion`);
  }
}
